<template lang="pug">
  div
    section.content-header(data-testid="content-header-bcard-add")
      h1
        template(v-if="isClone") 既存人物
        template(v-else) 新規人物
        template(v-if="isModeManual") （直接入力して登録）
        template(v-else) （画像からの登録）

    section.content(data-testid="content-bcard-add")

      form(ref="form", @submit.prevent="postData", novalidate)

        mixin btnbar
          .bcard-btnbar(class!=attributes.class)
            button.btn.btn-primary(type="submit", data-testid="add-btn-submit") 登録
            |
            |
            router-link.btn.btn-default(:to="closeLocation", data-testid="-btn-cancel") キャンセル

        +btnbar

        app-layout(@leftScroll="performSticky")
          template(slot="left")
            .row
              .col-xs-6(:class="{'-sticky-wrap': isModeManual, 'col-xs-push-6': isModeManual}")
                .-sticky-element(ref="stickyElement")
                  file-droppable(
                    v-if="clone.fileDropReloader",
                    v-model="bcard.images",
                    :main-image-id="bcard.image_id"
                    :multi="true",
                    :required="isNewPerson && isModeImage",
                    :edit_mode="isImageEditMode",
                    :view_mode="!isImageEditMode"
                  )
                  template(v-if="isModeManual && isClone")
                    .checkbox.checkbox-rich.form-group
                      label.form-control-static
                        input(type="checkbox" v-model="clone.useClonedImages" @change="changeClonedFlag")
                        span: i.fa.fa-check.fa-lg
                        | {{clone.fullName}} さんの最新名刺画像を流用する
                .form-group(v-if="isModeImage")
                  .help-block
                    button.btn.btn-info.btn-xs(type="button" @click="modalImageInfo = true")
                      i.fa.fa-info-circle
                      |
                      | 名刺画像撮影時の注意事項

              .col-xs-6(ref="stickySibling", :class="{'col-xs-pull-6': isModeManual}")
                template(v-if="isModeManual")
                  .row
                    .col-xs-6
                      card-field(v-model="bcard.main.last_name" :maxlength="maxlengths.last_name" @input="setFurigana")
                    .col-xs-6
                      card-field(v-model="bcard.main.first_name" :maxlength="maxlengths.first_name" @input="setFurigana")
                  .row
                    .col-xs-6
                      .badge.bg-aqua.pull-right(v-if="isNewPerson && isModeManual"): i.fa.fa-search
                      card-field(v-model="bcard.main.last_kana" :maxlength="maxlengths.last_kana")
                    .col-xs-6
                      .badge.bg-aqua.pull-right(v-if="isNewPerson && isModeManual"): i.fa.fa-search
                      card-field(v-model="bcard.main.first_kana" :maxlength="maxlengths.first_kana")
                  card-field(v-model="bcard.main.corporate_name" :maxlength="maxlengths.corporate_name")
                  .badge.bg-aqua.pull-right(v-if="isNewPerson && isModeManual"): i.fa.fa-search
                  card-field(v-model="bcard.main.corporate_kana" :maxlength="maxlengths.corporate_kana")
                  card-field(v-model="bcard.main.company_name" :maxlength="maxlengths.company_name")
                  card-field(v-model="bcard.main.company_kana" :maxlength="maxlengths.company_kana")
                  .row
                    .col-xs-6
                      card-field(v-model="bcard.main.dept" :maxlength="maxlengths.dept")
                    .col-xs-6
                      card-field(v-model="bcard.main.post" :maxlength="maxlengths.post")
                  card-field(v-model="bcard.main.dept_post" :maxlength="maxlengths.dept_post")

                  br
                  card-form-office(office-no="1" v-model="bcard.office1" :maxlengths="maxlengths")
                  br
                  card-form-office(office-no="2" v-model="bcard.office2" :maxlengths="maxlengths")

                template(v-else)
                  .form-group
                    label(for="") 名刺画像の切り抜き
                    .radio.radio-rich
                      label(data-testid="radio-crop")
                        input(
                          type="radio",
                          name="ocr_crop",
                          :value="app_flag.ON",
                          v-model="bcard.ocr_crop"
                        )
                        span: i.fa.fa-dot-circle-o.fa-lg
                        | する
                      |
                      |
                      label(data-testid="radio-not-crop")
                        input(
                          type="radio",
                          name="ocr_crop",
                          :value="app_flag.OFF",
                          v-model="bcard.ocr_crop"
                        )
                        span: i.fa.fa-dot-circle-o.fa-lg
                        | しない

                    .help-block
                      p.text-info.bcard-comments ※ 「する」を選択した場合、メイン画像を解析する前に名刺部分のみを切り抜いた画像を自動で作成します。
                      p.text-info.bcard-comments ※ 「する」を選択しても、切り抜く必要がないと判断された場合は元の画像のみで解析されます。

                  .form-group
                    label(for="") 修正サービスの利用
                    .radio.radio-rich
                      label
                        template
                          input(
                            type="radio",
                            name="input_proxy",
                            :value="app_flag.ON",
                            v-model="bcard.input_proxy",
                            :disabled="!use_agency"
                          )
                          span: i.fa.fa-dot-circle-o.fa-lg
                          | する
                      |
                      |
                      label
                        template
                          input(
                            type="radio",
                            name="person[input_proxy]",
                            :value="app_flag.OFF",
                            v-model="bcard.input_proxy",
                            :disabled="!use_agency"
                          )
                          span: i.fa.fa-dot-circle-o.fa-lg
                          | しない

                    .help-block
                      p.text-info.bcard-comments ※ 「する」を選択した場合、メイン画像を解析した後、修正サービスによる名刺情報の修正を行います。
                      p.text-info.bcard-comments ※ 修正サービスとは、オペレーターによりメインの名刺画像の内容を確認して名刺情報の修正を行うサービスです。
                      p.text-info.bcard-comments(v-if="!use_agency") ※ 修正サービスのご利用にはオプション契約が必要です。

            hr
            p.lead
              i.fa.fa-fw.fa-handshake-o
              |
              |
              span 交換時情報
            exchange-form(
              v-model="bcard.exchange",
              :is-exchangers-editable="bcard.person.openflag === app_flag.ON",
              :use-accordion="true"
            )

            hr
            social-form(v-model="bcard.person")
            // 添付ファイルの登録は新規名刺登録時のみ
            template(v-if="isNewPerson")
              hr
              attachments-list-form

            hr
            .help-block
              p.bcard-required ※ (*)は必須項目です。

          template(slot="right")
            .-widget
              h5 公開区分
              openflag-view(v-if="isClone" v-model="bcard.person.openflag")
              openflag-field(v-else v-model="bcard.person.openflag" :show-label="false")

            .-widget
              h5 タグ
              sel-tags(
                v-model="bcard.tags",
                inputName="person[tags][][id]",
                :view_mode="false",
                :mode="{isDispPv: !isMgmt, canAddPv: !isAgentPage, isEdit: false}"
              )

            .-widget
              h5 共有メモ
              memo-form(v-model="bcard.person.memo")

            .-widget
              h5 個人メモ（非公開）
              pv-memo-form(v-model="bcard.pvPerson.memo")

            .-widget
              h5: a(href="#jbcard-collapse-keywords" data-toggle="collapse" aria-expanded="false" data-testid="link-keyword") 検索キーワード
                |
                |
                i.fa.fa-caret-down
                i.fa.fa-caret-up
              pv-keywords-form#jbcard-collapse-keywords.collapse(v-model="pvKeywords")

      //- 流用候補
      .box.box-solid.box-info.candidates(v-if="isNewPerson && isModeManual" data-testid="duplicate-persons")
        a.box-header.reverse-collapse-icon(href="#" data-toggle="collapse" data-target="#candidate-list" aria-expanded="false" aria-controls="candidate-list" title="開閉")
          i.fa.fa-caret-down.pull-right
          i.fa.fa-caret-up.pull-right
          | 氏名や会社名が一致した人物
        .box-body.collapse#candidate-list
          loading(v-if="loadingCandidates", :height="80")
          ul.list-group(v-else-if="Object.keys(candidates).length")
            template(v-for="(_persons, result) in candidates")
              li.list-group-item(v-for="person in _persons", :key="person.id" :data-testid="person.full_name")
                .media.bcard-card-media.with-image
                  .media-left
                    img.media-object.bcard-card-img(:src="app_imgsrc.now_loading" v-src:thumbnail="person.image_url")
                  .media-body
                    h4.media-heading.bcard-ui-userdata
                      a(href='#', @click.prevent="openModalBcard(person.id)", data-testid="-link-full-name")
                        i.fa.fa-fw.bcard-fa-person-private(v-if="person.openflag === '0'" title="非公開")
                        | {{person.full_name}}
                    .bcard-ui-userdata.text-muted(v-if="person.corporate_name") {{person.corporate_name}}
                    .bcard-ui-userdata.text-muted(v-if="person.dept") {{person.dept}}
                    .bcard-ui-userdata.text-muted(v-if="person.post") {{person.post}}
                    .bcard-ui-userdata.text-muted.text-nowrap {{person.formatted_exdate}}
                    .bcard-btnbar.-bottom
                      router-link.btn.btn-success(
                        :to="{name: 'addcard-manual-copy', params: {init: true, sidPerson: person.id, item: person}}"
                        data-testid="-btn-same-person") この人物に追加
          p.text-center(v-else) 見つかりませんでした。

    portal(to="modal")
      app-modal(type="default" v-model="modalImageInfo")
        template(slot="title") 名刺画像撮影時の注意事項
        ul
          li 名刺全体が画像中央に写るように撮影してください。
          li 名刺は極力、真っ直ぐになるよう撮影してください。
          li 撮影時、反射光が写り込まないようにしてください。
          li 全体または一部が暗くならないようにしてください。
          li 背景は一様かつ名刺画像と境目がわかる色(名刺色が白に対して黒の背景等はっきりするもの)にして撮影してください。
          li 切り抜きを行うには、画像中の上下左右それぞれに余白(名刺と背景の差分)を空けて撮影してください。
          li 撮影画像は、解像度：300～1200dpiの範囲内でかつ用紙サイズ：A3(600dpi)のピクセルサイズ以下で撮影してください。

      //- 名刺情報
      modal-bcard(v-model="modalBcard")
</template>

<script>
import historykana from 'historykana'
import mixinForm from '@/mixins/form'
import Loading from '@/components/molecules/Loading'
import AppModal from '@/components/templates/AppModal'
import AppLayout from '@/components/templates/AppLayout'
import ModalBcard from '@/components/organisms/ModalBcard'
import SelTags from '@/components/organisms/SelTags'
import FileDroppable from '@/components/organisms/FileDroppable'
import CardField from '@/components/molecules/CardField'
import CardFormOffice from '@/components/organisms/forms/CardFormOffice'
import SocialForm from '@/components/organisms/forms/SocialForm'
import ExchangeForm from '@/components/organisms/forms/ExchangeForm'
import AttachmentsListForm from '@/components/organisms/forms/AttachmentsListForm'
import MemoForm from '@/components/organisms/forms/MemoForm'
import PvMemoForm from '@/components/organisms/forms/PvMemoForm'
import PvKeywordsForm from '@/components/organisms/forms/PvKeywordsForm'
import OpenflagView from '@/components/molecules/OpenflagView'
import OpenflagField from '@/components/molecules/OpenflagField'

import RepositoryFactory from '@/repositories/RepositoryFactory'

const NewBcardRepository = RepositoryFactory.get('newbcard')
const PersonRepository = RepositoryFactory.get('person')
const InputProxySettingsRepository = RepositoryFactory.get('inputproxysettings')

// 初期値
const initialBcard = {
  image_id: null, // main画像ID
  images: [],
  // OCR切り抜きフラグ
  ocr_crop: '1', // app_flag.ON
  // 修正サービス利用有無
  input_proxy: '0', // app_flag.OFF
  main: {
    last_name: {
      label: '姓',
      field: 'last_name',
      value: '',
      checked: false,
      required: true
    },
    first_name: {
      label: '名',
      field: 'first_name',
      value: '',
      checked: false
    },
    last_kana: {
      label: '姓（よみがな）',
      field: 'last_kana',
      value: '',
      checked: false,
      required: true
    },
    first_kana: {
      label: '名（よみがな）',
      field: 'first_kana',
      value: '',
      checked: false
    },
    corporate_name: {
      label: '会社名',
      field: 'corporate_name',
      value: '',
      checked: false,
      required: true
    },
    corporate_kana: {
      label: '会社名（よみがな）',
      field: 'corporate_kana',
      value: '',
      checked: false,
      required: true
    },
    company_name: {
      label: 'カンパニー名',
      field: 'company_name',
      value: '',
      checked: false
    },
    company_kana: {
      label: 'カンパニー名（よみがな）',
      field: 'company_kana',
      value: '',
      checked: false
    },
    dept: {
      label: '部署名',
      field: 'dept',
      value: '',
      checked: false
    },
    post: {
      label: '役職',
      field: 'post',
      value: '',
      checked: false
    },
    dept_post: {
      label: '部署名＋役職',
      field: 'dept_post',
      value: '',
      checked: false
    }
  },
  office1: {
    o1_office_name: {
      label: '事業所名',
      field: 'o1_office_name',
      value: '',
      checked: false
    },
    o1_zipcode: {
      label: '郵便番号',
      field: 'o1_zipcode',
      value: '',
      checked: false
    },
    o1_address1: {
      label: '住所1',
      field: 'o1_address1',
      value: '',
      checked: false
    },
    o1_address2: {
      label: '住所2',
      field: 'o1_address2',
      value: '',
      checked: false
    },
    o1_tel1: {
      label: '電話番号1',
      field: 'o1_tel1',
      value: '',
      checked: false
    },
    o1_naisen1: {
      label: '電話番号1内線',
      field: 'o1_naisen1',
      value: '',
      checked: false
    },
    o1_tel2: {
      label: '電話番号2',
      field: 'o1_tel2',
      value: '',
      checked: false
    },
    o1_naisen2: {
      label: '電話番号2内線',
      field: 'o1_naisen2',
      value: '',
      checked: false
    },
    o1_mobile: {
      label: '携帯電話',
      field: 'o1_mobile',
      value: '',
      checked: false
    },
    o1_fax: {
      label: 'FAX',
      field: 'o1_fax',
      value: '',
      checked: false
    },
    o1_mail: {
      label: 'メールアドレス',
      field: 'o1_mail',
      value: '',
      checked: false
    },
    o1_url: {
      label: 'URL',
      field: 'o1_url',
      value: '',
      checked: false
    }
  },
  office2: {
    o2_office_name: {
      label: '事業所名',
      field: 'o2_office_name',
      value: '',
      checked: false
    },
    o2_zipcode: {
      label: '郵便番号',
      field: 'o2_zipcode',
      value: '',
      checked: false
    },
    o2_address1: {
      label: '住所1',
      field: 'o2_address1',
      value: '',
      checked: false
    },
    o2_address2: {
      label: '住所2',
      field: 'o2_address2',
      value: '',
      checked: false
    },
    o2_tel1: {
      label: '電話番号1',
      field: 'o2_tel1',
      value: '',
      checked: false
    },
    o2_naisen1: {
      label: '電話番号1内線',
      field: 'o2_naisen1',
      value: '',
      checked: false
    },
    o2_tel2: {
      label: '電話番号2',
      field: 'o2_tel2',
      value: '',
      checked: false
    },
    o2_naisen2: {
      label: '電話番号2内線',
      field: 'o2_naisen2',
      value: '',
      checked: false
    },
    o2_mobile: {
      label: '携帯電話',
      field: 'o2_mobile',
      value: '',
      checked: false
    },
    o2_fax: {
      label: 'FAX',
      field: 'o2_fax',
      value: '',
      checked: false
    },
    o2_mail: {
      label: 'メールアドレス',
      field: 'o2_mail',
      value: '',
      checked: false
    },
    o2_url: {
      label: 'URL',
      field: 'o2_url',
      value: '',
      checked: false
    }
  },
  // レスポンスにはない、この画面で入力する
  exchange: {
    exchange_date: '',
    exchangers: [],
    ex_location: '',
    ex_trigger: '',
    age: '',
    inner_introducer: [],
    outer_introducer: []
  },
  // レスポンスにはない、この画面で入力する
  attachments: [],
  person: {
    // デフォルトは公開 app_flag.ON
    openflag: '1',
    memo: '',
    twitter_id: '',
    blog_url: ''
  },
  tags: [],
  pvPerson: {
    memo: '',
    keyword01: '',
    keyword02: '',
    keyword03: '',
    keyword04: '',
    keyword05: '',
    keyword06: '',
    keyword07: '',
    keyword08: '',
    keyword09: '',
    keyword10: ''
  }
}

const initialClone = {
  sidPerson: null,
  fullName: '---',
  useClonedImages: true,
  fileDropReloader: true,
  orgImageId: null,
  orgImages: []
}

/**
 * @var {object} リクエスト数を間引くための情報
 *    <timestamp>: {
 *      executed: {boolean}
 *    }
 */
let searchPersonsWatcher = {}
let searchPersonsInterval = null
let searchPersonsLastTimestamp = 0

export default {
  name: 'NewcardEdit',
  components: {
    Loading,
    AppModal,
    AppLayout,
    ModalBcard,
    FileDroppable,
    CardField,
    CardFormOffice,
    SocialForm,
    ExchangeForm,
    AttachmentsListForm,
    MemoForm,
    PvMemoForm,
    PvKeywordsForm,
    OpenflagView,
    OpenflagField,
    SelTags
  },
  mixins: [ mixinForm ],
  props: {
    // 人物IDが決まった場合にURLから入ってくる
    sidPerson: { type: [String, Number], required: false, default: null },
    /**
     * 画面遷移してきたときに存在する、仮の名刺データ
     */
    item: {
      type: Object,
      required: false,
      default: null
    }
  },
  data () {
    return {
      // 流用人物
      clone: {
      },
      // 入力データ
      bcard: {},

      maxlengths: {},

      // 同一人物選択
      loadingCandidates: false,
      candidates: {},

      // 名刺画像撮影時の注意事項
      modalImageInfo: false,

      // 自動ひらがな入力
      autoKanas: {
        last_name: {
          histories: []
        },
        first_name: {
          histories: []
        }
      },

      modalBcard: {
        isOpen: false,
        sidPerson: ''
      }
    }
  },
  computed: {
    mode () {
      return this.$route.name.indexOf('addcard-manual') === 0 ? 'manual' : 'image'
    },
    //   inputType () {
    //     return this.isModeConf ? 'hidden' : 'text'
    //   },
    //   isOpenflagEditable () {
    //     return !this.isModeConf && !this.bcard.sid_person
    //   }
    isClone () {
      return !!this.sidPerson
    },
    isNewPerson () {
      return !this.sidPerson
    },
    isModeManual () {
      return this.mode === 'manual'
    },
    isModeImage () {
      return this.mode === 'image'
    },
    /**
     * ライセンス情報取得
     * @return bool
     */
    use_agency () {
      const license = this.$store.getState('license')
      return (this.$store.state.base.u && license && license.contract_input) || false
    },
    isImageEditMode () {
      return this.isNewPerson || this.isModeImage || !this.clone.useClonedImages
    },
    // v-modelに使うのでsetterも必要
    pvKeywords: {
      get () {
        const pvKeywords = {}
        for (let field in this.bcard.pvPerson) {
          if (field.search('keyword') === 0) {
            pvKeywords[field] = this.bcard.pvPerson[field]
          }
        }
        return pvKeywords
      },
      set (pvKeywords) {
        for (let field in pvKeywords) {
          this.bcard.pvPerson[field] = pvKeywords[field]
        }
      }
    },
    fromPersonDetail () {
      return this.$route.name.indexOf('clone') >= 0
    },
    closeLocation () {
      return (this.fromPersonDetail
        ? { name: 'box-detail', params: { init: true, sidPerson: this.sidPerson } }
        : { name: 'top', params: {} })
    }
  },
  watch: {
    'bcard.main.last_kana.value' (value) {
      // 氏名かなと会社名かなが変更されたら同一人物検索を行う
      this.searchPersons()
    },
    'bcard.main.first_kana.value' (value) {
      // 氏名かなと会社名かなが変更されたら同一人物検索を行う
      this.searchPersons()
    },
    'bcard.main.corporate_kana.value' (value) {
      // 氏名かなと会社名かなが変更されたら同一人物検索を行う
      this.searchPersons()
    }
  },
  created () {
    this.maxlengths = this.loadMaxlengths('Bcards')
    this.syncData()
    this.setInputProxy()
  },
  methods: {
    syncData () {
      this.bcard = JSON.parse(JSON.stringify(initialBcard))
      this.clone = JSON.parse(JSON.stringify(initialClone))

      // 人物が決まっている場合（人物詳細or「この人物に追加」から遷移）
      if (this.sidPerson) {
        // 元になる仮データ
        if (this.item) {
          // 仮データをセット
          this.setCloneData(this.item)
        }

        // DBからデータ取得
        this.getCloneData()
      }
    },
    setInputProxy () {
      // 修正サービスの利用：以下をすべて満たす場合のみ初期値をONにする
      // - 契約情報の「修正サービス」が「利用する」になっている
      // - #264 修正サービス設定で初期値の設定が「する」になっている
      const vm = this
      InputProxySettingsRepository.get()
        .then(function (response) {
          let data = vm.getApiData(response)
          if (vm.use_agency && data.data.default_input_proxy === vm.app_flag.ON) {
            vm.bcard.input_proxy = vm.app_flag.ON
          }
        })
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
    },
    performSticky (e) {
      const stickyElement = this.$refs.stickyElement
      const stickySibling = this.$refs.stickySibling
      stickyElement.style.top = Math.min(
        stickySibling.offsetHeight - stickyElement.offsetHeight,
        e.target.scrollTop
      ) + 'px'
    },
    /**
     * 既存人物の初期データセット
     */
    getCloneData () {
      // 人物流用時、デフォルトは「画像を流用する」
      this.clone.useClonedImages = true

      const vm = this
      PersonRepository.get(this.sidPerson, this.isMgmt)
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            let data = vm.getApiData(response).data

            vm.setCloneData(data)
          }
        })
        // システムエラー
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || '名刺人物情報を取得できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
    },
    /**
     * 姓名が変更されたらふりがなを設定する（@inputなのでwatchより細かく＝漢字変換中でも反応する）
     */
    setFurigana (value) {
      const e = value.$event

      // 漢字変換の場合（safariで発生）
      if (e.inputType === 'deleteCompositionText') {
        return
      }

      const nameField = value.field
      const nameValue = (e.target && e.target.value) || ''
      const kanaField = nameField.replace('_name', '_kana')

      if (nameValue.length === 0) {
        this.autoKanas[nameField].histories.splice(0)
      }
      else {
        this.autoKanas[nameField].histories.push(nameValue)
      }

      // TODO bcardを更新する（dataはcomputed）
      this.bcard.main[kanaField].value = historykana(this.autoKanas[nameField].histories)
    },
    /**
     * 氏名かなと会社名かなが変更されたら同一人物検索を行う
     */
    searchPersons () {
      // すでに人物が紐づいている場合は何もしない
      if (this.isClone) return

      const step = 1000 // ms

      // 追跡用
      const timestamp = +new Date()
      searchPersonsWatcher[timestamp] = {
        executed: false
      }
      // console.log('call ' + this.bcard.main.last_kana.value)

      // @inputのイベントを間引いてリクエストを呼ぶ
      clearInterval(searchPersonsInterval) // 前回のintervalはもう不要なので削除
      searchPersonsInterval = setInterval(() => {
        // 前回実行から1000ms経過してたら実行、あるいは、
        if ((timestamp - searchPersonsLastTimestamp > step) ||
            // 前回実行から1000ms経過してなくても、その後1000ms変更が起きなかったら実行
            ((+new Date()) - timestamp > step)) {
          // console.log('execute ' + this.bcard.main.last_kana.value)
          searchPersonsLastTimestamp = timestamp
          searchPersonsWatcher[timestamp].executed = true
          this._execSearchPersons()
        }

        if (searchPersonsWatcher[timestamp].executed) {
          // console.log('clear ' + this.bcard.main.last_kana.value)
          clearInterval(searchPersonsInterval)
        }
      }, step)
    },
    _execSearchPersons () {
      const last_kana = this.bcard.main.last_kana.value
      const first_kana = this.bcard.main.first_kana.value
      const corporate_kana = this.bcard.main.corporate_kana.value

      if (!last_kana && !first_kana && !corporate_kana) {
        return
      }

      const vm = this
      // 選択肢取得
      this.loadingCandidates = true
      PersonRepository.postSearchDups({
        last_kana,
        first_kana,
        corporate_kana
      })
        .then(function (response) {
          let data = vm.getApiData(response)
          // hitbothを先にするために、キーを指定して代入する
          vm.candidates = {}
          if ('hitboth' in data.data) {
            vm.candidates.hitboth = data.data.hitboth
          }
          if ('hitname' in data.data) {
            vm.candidates.hitname = data.data.hitname
          }
          $('#candidate-list').collapse('show')
        })
        // .catch(function (error) {
        //   alert('TODO エラー処理')
        // })
        .finally(function () {
          vm.loadingCandidates = false
        })
    },
    /**
     * 入力欄を人物情報で埋める
     */
    setCloneData (data) {
      // 表示データの上書き
      this.clone.fullName = data.full_name

      // 入力データの上書き
      // 入力データの上書き
      if (this.isModeManual) {
        this.bcard.image_id = data.image_id
        this.bcard.images = data.images
        // useClonedImagesを切り替えて戻すときのために取っておく
        this.clone.orgImageId = data.image_id
        this.clone.orgImages = JSON.parse(JSON.stringify(data.images || {}))
      }
      for (let field in this.bcard.main) {
        this.bcard.main[field].value = data[field]
      }
      for (let field in this.bcard.office1) {
        this.bcard.office1[field].value = data[field]
      }
      for (let field in this.bcard.office2) {
        this.bcard.office2[field].value = data[field]
      }
      // undefinedエラーを避けるためにいくつか初期値を定義してる
      this.bcard.person = {
        openflag: (data.person && data.person.openflag) || initialBcard.person.openflag,
        memo: (data.person && data.person.memo) || initialBcard.person.memo,
        twitter_id: (data.person && data.person.twitter_id) || initialBcard.person.twitter_id,
        blog_url: (data.person && data.person.blog_url) || initialBcard.person.blog_url
      }
      this.bcard.tags = data.tags || []
      this.bcard.pvPerson = (Array.isArray(data.pv_person) ? data.pv_person.length > 0 : data.pv_person) || { memo: '' }
    },
    /**
     * 画像流用切り替え
     */
    changeClonedFlag () {
      const vm = this

      // 流用モードに切り替えるときは、元データに戻す
      // 編集モードに切り替えるときは、データを空にする
      if (this.clone.useClonedImages) {
        this.bcard.image_id = this.clone.orgImageId
        this.bcard.images = JSON.parse(JSON.stringify(this.clone.orgImages))
      }
      else {
        this.bcard.image_id = null
        this.bcard.images = []
      }

      // 選択した画像を破棄するために、コンポーネント再読み込み
      this.clone.fileDropReloader = false
      this.$nextTick(function () {
        vm.clone.fileDropReloader = true
      })
    },
    postData () {
      if (!this.checkFormValidity()) {
        this.showToast('入力内容をもう一度確認してください。', { type: 'danger' })
        return
      }

      const vm = this

      // 登録内容
      let bcardFormData = new FormData(this.$refs.form)

      // 既存の人物に紐づける場合、人物IDをセットする
      if (this.isClone) {
        bcardFormData.append('sid_person', this.sidPerson)
      }

      // 画像から登録の場合、OCR使用フラグをONにする
      if (this.isModeImage) {
        bcardFormData.append('input_ocr', this.app_flag.ON)
      }

      // FileListからFileを削除するための苦肉の策
      bcardFormData = this.appendFiles(bcardFormData)

      // API実行
      NewBcardRepository.post(bcardFormData)
        // 成功時処理
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            const data = vm.getApiData(response).data
            // vm.modalDone.isOpen = true
            // vm.modalDone.data = data

            // サイドメニューの件数更新
            vm.$store.dispatch('reloadSidemenu')

            // 完了画面へ移動
            vm.$router.push({
              name: vm.$route.name + '-done',
              params: {sidPerson: data.sid_person}
            })
          }
          else {
            // eslint-disable-next-line no-console
            console.log(response)
          }
        })

        // システムエラー
        .catch(function (error) {
          // console.log((error))
          vm.setErrorMessage(error)
          // const message = vm.getErrorMessage(error) || '名刺を登録できませんでした。'
          vm.showToast(vm.errors.join('<br>'), { type: 'danger' })
        })
    },
    /**
     * 同一人物に引っかかった人物の名刺情報を表示する
     * @param sidPerson
     */
    openModalBcard (sidPerson) {
      this.modalBcard.sidPerson = sidPerson
      this.modalBcard.isOpen = true
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/ {
    .-layout-left, .-layout-right {
      height: calc(100vh - 250px);
    }
  }

  .-sticky-wrap {
    position: relative;
    .-sticky-element {
      width: calc(100% - 15px);
      position: absolute;
      top: 0;
      left: 0;
      /*z-index: 1000; !* date-pickerが900なので *!*/
    }
  }

  /**
   * 流用候補の設定
   */
  /deep/ .-layout-right:after {
    /* 候補を出すための余白 */
    /*padding-bottom: 4em;*/
    /* 仮対応 https://stackoverflow.com/questions/39736658/padding-and-overflow-scroll-in-microsoft-edge */
    content: '';
    width: 100%;
    height: 4em;
    display: block;
  }
  section.content {
    position: relative;
  }
  .candidates {
    position: absolute;
    bottom: 15px;
    right: 35px;
    width: calc(25% - 30px);
    margin-bottom: 0;

    .list-group {
      margin: -10px;

      .list-group-item {
        border-left: 0;
        border-right: 0;
        border-bottom: 0;
        width: 400px;

        &:first-child {
          border-top: 0;
        }
      }
    }
  }

  .box-body.collapse {
    overflow-y: auto;
    max-height: calc(100vh - 300px);
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/box/NewCardEdit.vue